<template>
  <div class="project">
    <div class="title">
      <label>
      <a :href="demo_url" target="_blank" title="Demo">
        {{name}}
      </a>
      </label>
      <a :href="demo_url" target="_blank" class="pull-right" title="Demo" v-tippy='{ placement : "top", arrow : true }'>
        <label class="pull-right demo">
          <i class="fas fa-external-link-alt"></i>
        </label>
      </a>
    </div>
    <p class="description">{{description}}</p>
    <div class="info">
      <label class="language pull-left">
        <i class="fas fa-circle" :style="'color:'+ color"></i>&nbsp;{{language}}
      </label>         
      <a :href="src_url" class="pull-right" target="_blank" title="Source Code" v-tippy='{ placement : "top", arrow : true }'>
        <label class="code"><i class="fas fa-code"></i></label>   
      </a>  
    </div>
  </div>


</template>

<script>

export default {
  components: {},
  name: 'Project',
  props: ["name", "demo_url", "src_url", "description", "stars", "forks", "language", "color"],
  methods: {},
  computed:{},
  created(){}
}
</script>

<style scoped lang="scss">

.project {
  position: relative;
  float: left;
  background-color: white;
  padding: 10px;
  height: 150px;
  width: 250px;
  margin: 10px;
  color: #586069 !important;
  text-align: left;
  font-family: Segoe UI;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}

.demo, .code {
  font-size: 15px;
  cursor: pointer;
  color: gray;  
  transition: color 0.5s;
}

.code:hover, .demo:hover{
  color: black;
}

.project .title a{
  color: rgba(73, 71, 71, 0.727) !important;
}

.project .description {
  margin-top: 10px;
}

.project .info {
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/Project.vue